import { BikeCard } from "./bikeCard";
import { MassagedBikeAndSub, Variant } from "./lib";

export const VariantGrid = ({
  variant,
  bikes
}: {
  variant: Variant;
  bikes: MassagedBikeAndSub[];
}) => {
  return (
    <section id={variant.type} className="flex flex-col gap-8">
      <div className="flex flex-col max-w-[500px] md:max-w-full self-center w-full">
        <h2 className="self-start">{variant.title}</h2>
        <p>{variant.description}</p>
      </div>
      <div className="flex flex-col items-center gap-6 md:grid md:grid-cols-3 md:grid-rows-auto md:grid-flow-row h-1/2 md:w-full">
        {bikes.map((bike, index) => {
          return <BikeCard key={index} bike={bike} />;
        })}
      </div>
    </section>
  );
};
